module.exports = __webpack_public_path__ + "static/img/bind-code-r.e5b49bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/bind-code-r.png
// module id = 3R0I
// module chunks = 4